import { render, staticRenderFns } from "./ApplicantProfileProgram.vue?vue&type=template&id=0f34fb45&scoped=true&"
import script from "./ApplicantProfileProgram.vue?vue&type=script&lang=js&"
export * from "./ApplicantProfileProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34fb45",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f34fb45')) {
      api.createRecord('0f34fb45', component.options)
    } else {
      api.reload('0f34fb45', component.options)
    }
    module.hot.accept("./ApplicantProfileProgram.vue?vue&type=template&id=0f34fb45&scoped=true&", function () {
      api.rerender('0f34fb45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/ApplicantProfileProgram.vue"
export default component.exports